var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-right":"20px"}},[_c('div',{staticClass:"cardStyle",staticStyle:{"height":"410px"},attrs:{"id":"sparePartsC"}})])}]

export { render, staticRenderFns }